import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

interface StudioActionDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmColor?: 'primary' | 'error' | 'warning';
  textLabel?: string;
  textPlaceholder?: string;
  onClose: () => void;
  onConfirm: (text?: string) => void;
}

const StudioActionDialog: React.FC<StudioActionDialogProps> = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Avbryt',
  confirmColor = 'primary',
  textLabel,
  textPlaceholder,
  onClose,
  onConfirm,
}) => {
  const [text, setText] = useState('');

  useEffect(() => {
    if (open) setText('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
        {textLabel && (
          <TextField
            autoFocus
            label={textLabel}
            placeholder={textPlaceholder}
            value={text}
            onChange={(event) => setText(event.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={() => onConfirm(textLabel ? text.trim() || undefined : undefined)}
          sx={{ textTransform: 'none' }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudioActionDialog;
